// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeMemberListBody = {
  poolId: string;
  statuses?: string[];
  cursor?: string | null;
  limit?: number | null;
};

export type typeMemberListOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    items: {
      userId: string;
      poolRole: "owner" | "admin" | "member";
      status:
        "pending" | "active" | "suspended" | "left" | "removed" | "rejected";
      joinedAt?: string | null;
      createdAt: string;
      username: string;
      displayName: string;
      avatarUrl?: string | null;
      contestStatus:
        "in" | "eliminated" | "revived" | "notPlaying" | "unavailable";
    }[];
    invited: {
      poolInviteId: string;
      invitedUserId: string;
      invitedByName: string;
      sentAtLabel: string;
      canRevoke: boolean;
      invitedDisplayName: string;
    }[];
    nextCursor?: string | null;
  };
};

export type typeMemberListOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeMemberListOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeMemberListOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaMemberListBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    statuses: {
      type: "array",
      items: { type: "string", maxLength: 3000, minLength: 1 },
    },
    cursor: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    limit: { oneOf: [{ type: "integer" }, { enum: [null] }] },
  },
  required: ["poolId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createMemberList(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaMemberListBody);
  }

  return async function postMemberList(
    payload: typeMemberListBody,
  ): Promise<typeMemberListOutput200 | typeMemberListOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postMemberList" failed before calling the network. #cbdf6034b625`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#cbdf6034b625" },
        },
        data: null,
      } as typeMemberListOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/member/list`,
      httpMethod: "POST",
      options,
    })) as typeMemberListOutput200 | typeMemberListOutput400;
  };
}
